import Vue from 'vue/dist/vue.js'
import Vuex from 'vuex'
import { firebaseMutations, firebaseAction } from 'vuexfire'
import { getField, updateField } from 'vuex-map-fields'
import { userRef, racePepsRef } from '../firebase'
import firebase from 'firebase'
import moment from 'moment'
import information from './modules/information'
import myRaces from './modules/myRaces'
import { pepsPath } from '../helpers/utils'
import _ from 'lodash'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    information,
    myRaces,
  },
  state: {
    races: {},
    race: {},
   // plannerSpeedDial: {},
    selectedPepPointId: '',
    markers: {},
    time: {
      selectedStartDate: '',
      selectedStartTime: '',
      selectedEndDate: '',
      selectedEndTime: ''
    },
    isMyRaces: false,
    isEvent: false,
    isOwnPep: false,
    isDistance: false,
    isEventEdit: false,
    isMetric: true,
    routeRendered: false
  },
  getters: {
    races: state => state.races,
    //plannerSpeedDial: state => state.plannerSpeedDial,
    race: state => state.race,
    isMyRaces: state => state.isMyRaces,
    isEventEdit: state => state.isEventEdit,
    routeRendered: state => state.routeRendered,
    raceInfo: state => state.race.event,
    isMetric: state => state.isMetric,
    currentRaceId: state => state.race['.key'],
    selectedPepPoint: state => state.selectedPepPointId ? state.race.data.racePepPoints[state.selectedPepPointId] : null,
    selectedDistancePepPoint: state => state.selectedPepPointId ? state.race.data.racePepPointsWoLocation[state.selectedPepPointId] : null,
    selectedPepPointId: state => state.selectedPepPointId,
    publicId: state => state.race.publicId,
    timezone: state => state.race.timezone ? state.race.timezone : state.race.data.timezone,
    isOwnPep: state => state.isOwnPep,
    isDistance: state => state.isDistance,
    getField
  },
  mutations: {
    setPepPointId(state, key) {
      console.log("setting pep to ")
      console.log(key)
      state.selectedPepPointId = key
    },
    emptyRace(state) {
      state.race = null
      console.log("empty state mutation")
      console.log(state.race)
    },
    setMyRaces(state, value) {
      console.log("setting myraces to: " + value)
      state.isMyRaces = value
    },
    setIsEvent(state, value) {
      console.log("setting event to: " + value)
      state.isEvent = value
    },
    setEventEdit(state, value) {
      console.log("setting eventEdit to: " + value)
      state.isEventEdit = value
    },
    setOwnPeps(state, value) {
      state.isOwnPep = value
    },
    setIsDistance(state, value) {
      state.isDistance = value
    },
    setRouteRendered(state, value) {
      state.routeRendered = value
    },
    updateField,
    ...firebaseMutations
  },
  actions: {//V
    setRacesRef: firebaseAction(({ bindFirebaseRef }, ref ) => {
      console.log("Setting races ref", ref)
      bindFirebaseRef('races', ref)
    }),
/*     setPlannerSpeedDialRef: firebaseAction(({ bindFirebaseRef }, ref) => {
      console.log("Setting races ref", ref)
      bindFirebaseRef('plannerSpeedDial', ref)
    }), */
    setRaceRef: firebaseAction(({ bindFirebaseRef, commit }, data ) => {
      console.log(data)
      commit("setMyRaces", data.myRaces)
      commit("setIsEvent", data.isEvent)
      commit("setEventEdit", data.eventEdit)

      return new Promise((resolve, reject) => {
        bindFirebaseRef('race', data.ref, {
          cancelCallback: function(err) {
            console.log("cancel callback", err)
          }, // Cancel callback passed to Firebase when listening for events
          readyCallback: function(err) {
            console.log("ready callback", err)
            resolve()
          }, // Callback called once the data has been loaded. Useful for SSR
          errorCallback: function(err) {
            console.log("error callback", err)
            reject()
          }, // Callback called when there is an error loading the data. Useful for SSR
          //wait: Boolean, // (Arrays only) Should Vuexfire wait for the whole array to be populated. Defaults to true
        })
      })

    }),
    unbindRaceRef: firebaseAction(({ unbindFirebaseRef, commit, dispatch }) => {
      console.log("unbinding race ref")
      commit("setMyRaces", false)
      commit("setIsEvent", false)
      commit('setOwnPeps', false)
      commit("setEventEdit", false)
      dispatch('unInitializeInfo')
      return unbindFirebaseRef('race')
    }),
    removeRace(context, id) {
      console.log("removing race")
      return userRef.child(firebase.auth().currentUser.uid).child('races').child(id).remove()
    },
    updateRouteRendered({ commit }, value) {
      commit('setRouteRendered', value)
    },
    addPepPoint(context, e) {
      var id = context.state.race['.key']

      console.log("raceId " + id)

      return racePepsRef.child(id).child('data').child('racePepPoints').push({
          message: '',
          runnerPoint: context.state.isEventEdit ? null : true,
          speakOnEnter: 1,
          location: {
            latitude: e.lngLat.lat,
            longitude: e.lngLat.lng
          },
          timestamp: moment().unix()
        })
    },
    addPepPointWoLocation(context) {
      var id = context.state.race['.key']

      console.log("raceId " + id)

      return racePepsRef.child(id).child('data').child('racePepPointsWoLocation').push({
        message: '',
        runnerPoint: context.state.isEventEdit ? null : true,
        speakOnEnter: 1,
        distanceLocation: 1000,
        timestamp: moment().unix()
      })
    },
    removePepPoint(context, key) {
      const id = context.state.race['.key']
      console.log("Removing pep point")
      console.log(key)
      context.commit('setPepPointId', '')
      return racePepsRef.child(id).child('data').child('racePepPoints').child(key).remove()
    },
    removePepPointWoLocation(context, key) {
      const id = context.state.race['.key']
      console.log("Removing pep point")
      console.log(key)
      context.commit('setPepPointId', '')
      return racePepsRef.child(id).child('data').child('racePepPointsWoLocation').child(key).remove()
    },
    selectPepPoint(context, key) {
      console.log("selectPepPoint() action")
      context.commit('setPepPointId', key)
    },
    requestLanguageDetection({ state }, input) {
      const pepPointId = state.selectedPepPointId
      const raceId = state.race['.key']

      firebase.auth().currentUser.getIdToken().then((token) => {
        var xhr = new XMLHttpRequest()
        xhr.open('GET', `https://us-central1-racepeps.cloudfunctions.net/api/requestLanguageDetection/${raceId}/${pepPointId}/${input}`, true)
        xhr.setRequestHeader('Authorization', 'Bearer ' + token)
        xhr.send()
      })
    },
    toggleOwnPeps({commit, state}) {
      commit('setOwnPeps', !state.isOwnPep)
    },
    updateIsDistance({commit}, input) {
      console.log(input)
      commit('setIsDistance', input)
    },
    updatePepText({ state }, input) {
      console.log("updatePepText() action")
      const id = state.race['.key']
      const path = input.path
      const regex = /\p{Emoji_Presentation}\p{Emoji_Modifier}*/gu;
      let message = input.message.replace(regex, ' ') //to block emojis
      racePepsRef.child(id).child('data').child(path).child(state.selectedPepPointId).child('message').set(message)
    },
    updatePepDistance({ state }, input) {
      console.log("updatePepDistance() action")
      const id = state.race['.key']
      racePepsRef.child(id).child('data').child('racePepPointsWoLocation').child(state.selectedPepPointId).child('distanceLocation').set(Number(input))
    },
    updatePepCoords({ state }, input) {
      console.log("updatePepCoords() action")
      return new Promise((resolve, reject) => {
        const coords = input.coords
        const id = state.race['.key']
        const pepPointId = input.key
        racePepsRef.child(id).child('data').child('racePepPoints').child(pepPointId).child('location').set(coords).then(() => {
          resolve()
        }).catch((err) => {
          console.log(err)
          reject()
        })
      })

    },
    updatePepSoe({ state }, input) {
      console.log("updatePepSoe() action")
      const id = state.race['.key']
      racePepsRef.child(id).child('data').child(input.path).child(state.selectedPepPointId).child('speakOnEnter').set(input.soe)
    },
    setEndMessage( {state}, input) {
      const id = state.race['.key']
      if (input !== "") {
        racePepsRef.child(id).child('data').child('event').child('endMessage').set(input)
      } else {
        racePepsRef.child(id).child('data').child('event').child('endMessage').set(null)
      }

    },
    setRouteGroup({ state }, input) {
      const id = state.race['.key']
      if (input !== "") {
        racePepsRef.child(id).child('data').child('event').child('routeGroup').set(input)
      } else {
        racePepsRef.child(id).child('data').child('event').child('routeGroup').set(null)
      }

    },
    setDescription({state}, input) {
      const id = state.race['.key']
      if (input !== "") {
        racePepsRef.child(id).child('data').child('event').child('description').set(input)
      } else {
        racePepsRef.child(id).child('data').child('event').child('description').set(null)
      }
    },
    setRouteName({ state }, input) {
      const id = state.race['.key']
      let userRaceId = _.findKey(state.races, { publicId: id })
      if (userRaceId !== undefined && input !== "") {
        userRef.child(firebase.auth().currentUser.uid).child('races').child(userRaceId).child('event').child('name').set(input)
        racePepsRef.child(id).child('data').child('event').child('name').set(input)
      }
    },
    resetStore({commit}) {
      //TODO fiksaa
      console.log("resetStore action")
      //commit('reset')
    }
  }
})
